export interface ServerMetadata {
    readonly appUrl: string;
    readonly aiCrownEnabled: boolean;
    readonly aiRetainerEnabled: boolean;
    readonly aiRetainerJobLimit: number;
    readonly aiRetainerCadMode?: string | null;
}
